const types = {
  SET_USER: "SET_USER",
  SET_USER_BY_CREDENTIAL: "SET_USER_BY_CREDENTIAL",
  TOUCH_USER: "TOUCH_USER",
  RESET_USER: "RESET_USER",
  SWITCH_OPT_CLINIC: "SWITCH_OPT_CLINIC",
};

const module = {
  namespaced: true,
  state: {
    isLogin: false,
    user: {
      name: "",
      account: "",
      // roles: [],
      // permission: "",
      // permissionDetail: "",
      authClinics: [], //授權可操作診所
      optClinic: "", //目前操作診所
      optClinicName: "", //目前操作診所名稱
      optRoleID: "", //目前角色
      optRoleName: "", //目前角色名稱
      optPermissions: [], //目前權限
      systemRole: "",
      alliance: "", //具有分院
      touchDateTime: 0,
      biUrl: "", //BI報表URL
    },
  },
  actions: {
    actionSetUser({ commit }, user) {
      if (user) {
        user.touchDateTime = 0;
      }
      commit(types.SET_USER, user);
    },
    actionSetCredential({ commit }, payload) {
      commit(types.SET_USER_BY_CREDENTIAL, payload);
    },
    actionTouchUser({ commit }) {
      commit(types.TOUCH_USER);
    },
    actionResetUser({ commit }) {
      commit(types.RESET_USER);
    },
    actionSwitchClinic({ commit }, clinic) {
      commit(types.SWITCH_OPT_CLINIC, clinic);
    },
  },
  mutations: {
    [types.SET_USER](state, user) {
      state.isLogin = user ? true : false;
      state.user = user;
    },
    [types.SET_USER_BY_CREDENTIAL](state, { credential, clinic }) {
      state.isLogin = true;
      // console.log("credential:", credential);
      state.user.name = credential.name;
      state.user.account = credential.email;
      state.user.authClinics = credential.clinicRoles;
      state.user.systemRole = credential.systemRole;
      state.user.alliance = credential.alliance || "";
      state.user.biUrl = credential.biUrl || "";

      let clinicStaff = credential.clinicRoles.find(
        (cr) => cr.clinic === clinic
      );
      if (clinicStaff) {
        state.user.optClinic = clinicStaff.clinic;
        state.user.optClinicName = clinicStaff.clinicName;
        state.user.optRoleID = clinicStaff.roleID;
        state.user.optRoleName = clinicStaff.roleName;
        state.user.optPermissions = clinicStaff.permissions;
      } else {
        state.user.optClinic = "";
        state.user.optClinicName = "";
        state.user.optRoleID = "";
        state.user.optRoleName = "";
        state.user.optPermissions = [];
      }
    },
    [types.TOUCH_USER](state) {
      state.user.touchDateTime = Math.floor(new Date().getTime() / 1000);
    },
    [types.RESET_USER](state) {
      state.isLogin = false;
      state.user = {
        name: "",
        account: "",
        systemRole: "",
        authClinics: [], //授權可操作診所
        optClinic: "", //目前操作診所
        optClinicName: "", //目前操作診所名稱
        optRoleID: "", //目前角色
        optRoleName: "", //目前角色名稱
        optPermissions: [], //目前權限
        alliance: "", //具有分院
        touchDateTime: 0,
        biUrl: "", //BI報表URL
      };
    },
    [types.SWITCH_OPT_CLINIC](state, clinic) {
      let clinicStaff = state.user.authClinics.find(
        (cr) => cr.clinic === clinic
      );
      if (clinicStaff) {
        state.user.optClinic = clinicStaff.clinic;
        state.user.optClinicName = clinicStaff.clinicName;
        state.user.optRoleID = clinicStaff.roleID;
        state.user.optRoleName = clinicStaff.roleName;
        state.user.optPermissions = clinicStaff.permissions;
      } else {
        state.user.optClinic = "";
        state.user.optClinicName = "";
        state.user.optRoleID = "";
        state.user.optRoleName = "";
        state.user.optPermissions = [];
      }
    },
  },
  getters: {
    getFocusClinic: (state) => {
      //{"_id":"trial","name":"NxVet 動物之家"}
      return { _id: state.user.optClinic, name: state.user.optClinicName };
    },
    getUserInfo: (state) => {
      return state.user
    }
  },
};

export default module;
